import { ContractType } from '@shared/enums/contract-type';

export class OrderHistoryItem {
  orderServiceId: number;
  customerNumber: string;
  orderStatus: string;
  canBeCanceled: boolean;
  registeredDate: Date;
  salesPerson: string;
  customerName: string;
  hasContract: boolean;
  hasPendingPayment: boolean;
  hasPayment: boolean;
  dealerName: string;
  contractSigned: boolean;
  contractType: ContractType;
  isServiceOrder: boolean;
}

export interface OrderHistorySearchRequestV2 {
  searchPhrase?: string;
  fromDate?: Date;
  toDate?: Date;
  take?: number;
  currentPage?: number;
  dealerId?: string;
  salesPersonId?: string;
  showMyOrders?: boolean;
  showOrdersWithMissingImeis?: boolean;
  showVoiceSubscriptions?: boolean;
  showMobilePhoneOrders?: boolean;
  showMbbOrders?: boolean;
  showOrdersWaitingForCustomer?: boolean;
  showPendingOrders?: boolean;
  showFailedOrders?: boolean;
  showCancelledOrders?: boolean;
  showFinishedOrders?: boolean;
}

export interface OrderHistoryResponseV2 {
  currentPage: number;
  take: number;
  missingImeiCount: number;
  items: OrderHistoryItemV2[];
}

export enum OrderHistoryStatusFilter {
  showOrdersWaitingForCustomer = 'showOrdersWaitingForCustomer',
  showPendingOrders = 'showPendingOrders',
  showFailedOrders = 'showFailedOrders',
  showCancelledOrders = 'showCancelledOrders',
  showFinishedOrders = 'showFinishedOrders',
}

export enum OrderHistoryStatusCategory {
  WaitingForCustomer = 'WaitingForCustomer',
  InProgress = 'InProgress',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  Finished = 'Finished',
}

export type OrderHistoryItemV2 = {
  orderServiceId: number;
  status: Status;
  customer: CustomerInformation;
  registeredDate: Date;
  dealer: DealerInfo;
  isServiceOrder?: boolean;
  isMissingImei?: boolean;
  canBeCancelled: boolean;
};

export type CustomerInformation = {
  customerName: string;
  customerId: string;
};

export type DealerInfo = {
  dealerName: string;
  sellerName?: string;
};

export enum DetailedOrderStatus {
  WaitingForLogistics = 'WaitingForLogistics',
  SentFromLogistics = 'SentFromLogistics',
  FailedLogistics = 'FailedLogistics',
  WaitingForPayment = 'WaitingForPayment',
  WaitingForPorting = 'WaitingForPorting',
  WaitingForSmsSigning = 'WaitingForSmsSigning',
  WaitingForActivation = 'WaitingForActivation',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  PaymentCancelled = 'PaymentCancelled',
  PaymentExpired = 'PaymentExpired',
  PaymentFailed = 'PaymentFailed',
  Processing = 'Processing',
  Failed = 'Failed',
  IsDealtByOrderSupport = 'IsDealtByOrderSupport',
  BankIdInitiated = 'BankIdInitiated',
  BankIdMismatch = 'BankIdMismatch',
  BankIdSessionExpired = 'BankIdSessionExpired',
}

export enum DetailedOrderStatusMessage {
  WaitingForLogistics = 'Venter på logistikk',
  FailedLogistics = 'Logistikk feilet',
  SentFromLogistics = 'Sendt',
  WaitingForPayment = 'Venter på betaling',
  WaitingForPorting = 'Venter på overføring',
  WaitingForSmsSigning = 'Venter på SMS-signering',
  WaitingForActivation = 'Venter på aktivering',
  Completed = 'Fullført',
  Cancelled = 'Kansellert',
  Failed = 'Feilet',
  PaymentCancelled = 'Betaling kansellert',
  PaymentExpired = 'Betaling utløpt',
  PaymentFailed = 'Betaling feilet',
  Processing = 'Prosesserer',
  IsDealtByOrderSupport = 'Håndteres av ordrehåndtering',
  BankIdInitiated = 'Venter på BankID-signering',
  BankIdMismatch = 'Avvik i BankID-verifisering',
  BankIdSessionExpired = 'BankID-sesjonen utløpt',
}

export type Status = {
  statusCategory: OrderHistoryStatusCategory;
  detailedOrderStatuses: DetailedOrderStatus[];
};
